import * as React from "react"

import { cn } from "@/lib/utils"

type AuthPageShellProps = {
  children: React.ReactNode
  className?: string
  /** Override the inner content width (default `max-w-6xl`). */
  contentClassName?: string
}

/** Centered page wrapper shared by sign-in and sign-up. */
export function AuthPageShell({ children, className, contentClassName }: AuthPageShellProps) {
  return (
    <div
      className={cn(
        "relative z-[1] flex min-h-svh w-full items-center justify-center bg-muted p-4 font-[family-name:var(--font-primary)] md:p-6 dark:bg-content-canvas",
        className
      )}
    >
      <div className={cn("flex w-full max-w-6xl flex-col", contentClassName)}>
        {children}
      </div>
    </div>
  )
}
